import React from "react";
import Icon from "components/AppIcon";

const RECENT_CHANGES = [
  { id: 1, user: "Carlos Rodríguez", action: "Modificó política de contraseñas", time: "05/03/2026 22:45", icon: "Lock", color: "var(--color-primary)" },
  { id: 2, user: "Ana Martínez", action: "Actualizó plantilla de correo de activación", time: "05/03/2026 20:12", icon: "Mail", color: "var(--color-secondary)" },
  { id: 3, user: "Carlos Rodríguez", action: "Cambió tiempo de expiración de URL a 24h", time: "04/03/2026 15:30", icon: "Clock", color: "var(--color-warning)" },
  { id: 4, user: "Sistema", action: "Limpieza automática de logs ejecutada", time: "04/03/2026 02:00", icon: "Archive", color: "var(--color-success)" },
];

const STATUS_ITEMS = [
  { label: "Servidor SMTP", status: "Conectado", ok: true },
  { label: "Validación NIT", status: "Activa", ok: true },
  { label: "MFA", status: "Desactivado", ok: false },
  { label: "Almacenamiento", status: "68% usado", ok: true },
];

const ConfigStatusPanel = () => {
  return (
    <div className="space-y-4">
      {/* System Status */}
      <div className="rounded-xl border p-4" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        <h3 className="font-heading font-700 text-sm mb-3" style={{ color: "var(--color-foreground)" }}>Estado del Sistema</h3>
        <div className="space-y-2">
          {STATUS_ITEMS?.map((item) => (
            <div key={item?.label} className="flex items-center justify-between">
              <span className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>{item?.label}</span>
              <div className="flex items-center gap-1.5">
                <div className="w-2 h-2 rounded-full" style={{ backgroundColor: item?.ok ? "var(--color-success)" : "var(--color-warning)" }} />
                <span className="text-xs font-caption font-600" style={{ color: item?.ok ? "var(--color-success)" : "var(--color-warning)" }}>{item?.status}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Recent Changes */}
      <div className="rounded-xl border p-4" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        <h3 className="font-heading font-700 text-sm mb-3" style={{ color: "var(--color-foreground)" }}>Cambios Recientes</h3>
        <div className="space-y-3">
          {RECENT_CHANGES?.map((change) => (
            <div key={change?.id} className="flex gap-3">
              <div className="w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: `${change?.color}18` }}>
                <Icon name={change?.icon} size={13} color={change?.color} />
              </div>
              <div className="min-w-0">
                <p className="text-xs font-caption font-600 truncate" style={{ color: "var(--color-foreground)" }}>{change?.action}</p>
                <p className="text-xs font-caption" style={{ color: "var(--color-muted-foreground)" }}>{change?.user}</p>
                <p className="text-xs font-data" style={{ color: "var(--color-muted-foreground)" }}>{change?.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Quick Actions */}
      <div className="rounded-xl border p-4" style={{ backgroundColor: "var(--color-card)", borderColor: "var(--color-border)" }}>
        <h3 className="font-heading font-700 text-sm mb-3" style={{ color: "var(--color-foreground)" }}>Acciones Rápidas</h3>
        <div className="space-y-2">
          {[
            { label: "Exportar configuración", icon: "Download" },
            { label: "Restaurar valores por defecto", icon: "RotateCcw" },
            { label: "Ver log completo", icon: "FileText" },
          ]?.map((action) => (
            <button
              key={action?.label}
              className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-caption transition-base text-left"
              style={{ backgroundColor: "var(--color-muted)", color: "var(--color-foreground)" }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "var(--color-border)"}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "var(--color-muted)"}
            >
              <Icon name={action?.icon} size={13} color="var(--color-primary)" />
              {action?.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ConfigStatusPanel;